import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appState: "",
  message: "",
  open: false,
  error: false,
  Loading: false,
  islogin: false,
  user: null,
  token: null,
};
const Reducer = createSlice({
  name: "seulah",
  initialState,
  reducers: {
    Loading: (state, action) => {
      const { Loading } = action.payload;
      state.Loading = Loading;
    },
    SetAppState: (state, action) => {
      state.appState = action.payload;
    },

    Message: (state, action) => {
      const { message, open, error } = action.payload;
      state.message = message;
      state.open = open;
      state.error = error;
    },
    Auth: (state, action) => {
      const { user, islogin } = action.payload;
      state.islogin = islogin;
      state.user = user;
    },
  },
});
export const { Message, SetAppState, Loading, Auth } = Reducer.actions;

export default Reducer.reducer;
